// Types for AGG graphQL queries are NOT autogenerated in CFE
// This file was manually created
export var ActivityProduct = /*#__PURE__*/function (ActivityProduct) {
  ActivityProduct["JIRA"] = "jira";
  ActivityProduct["CONFLUENCE"] = "confluence";
  ActivityProduct["ATLAS"] = "townsquare";
  ActivityProduct["GRAPH"] = "graph";
  return ActivityProduct;
}({});
export var VIEWED_EVENT = /*#__PURE__*/function (VIEWED_EVENT) {
  VIEWED_EVENT["VIEWED"] = "viewed";
  VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
  return VIEWED_EVENT;
}({});
export var WORKED_EVENT = /*#__PURE__*/function (WORKED_EVENT) {
  WORKED_EVENT["COMMENTED"] = "commented";
  WORKED_EVENT["CREATED"] = "created";
  WORKED_EVENT["EDITED"] = "edited";
  WORKED_EVENT["PUBLISHED"] = "published";
  WORKED_EVENT["UPDATED"] = "updated";
  return WORKED_EVENT;
}({});
var ExternalDocumentCategory = /*#__PURE__*/function (ExternalDocumentCategory) {
  ExternalDocumentCategory["DOCUMENT"] = "DOCUMENT";
  ExternalDocumentCategory["PRESENTATION"] = "PRESENTATION";
  ExternalDocumentCategory["SPREADSHEET"] = "SPREADSHEET";
  return ExternalDocumentCategory;
}(ExternalDocumentCategory || {});
export var isRemoteLinkActivity = function isRemoteLinkActivity(activity) {
  return activity.type === 'remote-link';
};
export var isDocumentActivity = function isDocumentActivity(activity) {
  return activity.type === 'document';
};
export var isGraphActivity = function isGraphActivity(activity) {
  return activity.product === 'graph';
};
export var is1PActivity = function is1PActivity(activity) {
  return activity.product === 'confluence' || activity.product === 'jira' || activity.product === 'townsquare';
};